module.exports = __webpack_public_path__ + "static/img/annoy.ed9045e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/annoy.jpg
// module id = IszB
// module chunks = 1